<template>

    <b-row v-if="loading">
        <b-col>
            <article class="page" :class="'page-' + [data.slug]" v-if="data">
                <h2>{{ data.title.rendered }}</h2>
                <div class="content" v-html="data.content.rendered"></div>
            </article>
            <!--<error v-else></error>-->
        </b-col>
    </b-row>
</template>

<script>
    import error from './error'
    import app from '../store/store2'

    export default {
        name: 'Page',
        data: function() {
            return {
                data: '',
                loading: false,
                edit: false,
            }
        },
        props: ['slug'],
        mounted() {
            console.log( app.pageurl + this.slug );
            this.$http.get( app.pageurl + this.slug ).then( response => {
                //console.log( response.data[0] );
                this.data = response.data[0];
            } );
            this.loading = true;
        },
        methods: {
            editPage: function() {
                this.edit = true;
            },
            savePage: function() {
                this.edit = false;
            }
        },
        watch: {
            slug: function( slug ) {
                //console.log( slug );
                this.$http.get( app.pageurl + this.slug ).then( response => {
                    //console.log( response.data[0] );
                    this.data = response.data[0];
                } );
                this.loading = true;
            }
        },
        components: {
            error,
        },
    }

</script>



// WEBPACK FOOTER //
// src/components/page.vue